import './smartGuides.css';

const OVERLAY_CLASS = 'mileslide-guide-overlay';
const LINE_CLASS = 'mileslide-guide';

/**
 * A guide is a position and an extent; which of those is x and which is y
 * depends on the kind. Everything downstream is just four CSS offsets.
 */
const boxFor = (guide) => {
  if (guide.type === 'align') {
    return guide.axis === 'x'
      ? {
          modifier: 'align-x',
          left: guide.position,
          top: guide.start,
          height: guide.end - guide.start,
        }
      : {
          modifier: 'align-y',
          top: guide.position,
          left: guide.start,
          width: guide.end - guide.start,
        };
  }
  return guide.dimension === 'width'
    ? {
        modifier: 'size-width',
        left: guide.start,
        top: guide.at,
        width: guide.end - guide.start,
      }
    : {
        modifier: 'size-height',
        left: guide.at,
        top: guide.start,
        height: guide.end - guide.start,
      };
};

const px = (value) => (value === undefined ? '' : `${value}px`);

/**
 * Draws guide lines over a slide. Nodes are pooled and rewritten in place — a
 * gesture repaints this on every mousemove, so creating and dropping elements
 * each frame would be wasteful.
 */
export function createGuideOverlay(slideRoot) {
  // A mouseup outside the drag surface never reaches the handler that ends a
  // session, so an earlier overlay can still be here holding stale lines.
  slideRoot.querySelectorAll(`.${OVERLAY_CLASS}`).forEach((stale) => stale.remove());

  const element = document.createElement('div');
  element.className = OVERLAY_CLASS;
  slideRoot.appendChild(element);

  const pool = [];

  const render = (guides) => {
    guides.forEach((guide, index) => {
      let node = pool[index];
      if (!node) {
        node = document.createElement('div');
        element.appendChild(node);
        pool[index] = node;
      }
      const box = boxFor(guide);
      node.className = `${LINE_CLASS} ${LINE_CLASS}--${box.modifier}`;
      node.style.left = px(box.left);
      node.style.top = px(box.top);
      node.style.width = px(box.width);
      node.style.height = px(box.height);
    });

    pool.splice(guides.length).forEach((node) => node.remove());
  };

  const destroy = () => {
    pool.length = 0;
    element.remove();
  };

  return { render, destroy };
}
